// Renders a word with every "U" wrapped in the animated purple<->green shift.
export function Wordmark({ text, className }) {
  return (
    <span className={className}>
      {[...(text || '')].map((ch, i) =>
        ch.toUpperCase() === 'U' ? (
          <span key={i} className="u-dynamic inline-block">
            {ch}
          </span>
        ) : (
          <span key={i}>{ch}</span>
        )
      )}
    </span>
  );
}
